export interface AuthorProfile {
  slug: string;
  name: string;
  email: string;
  role: string;
  image: string;
  about: string;
  education?: string;
  socialLink: string;
  socialType: "linkedin" | "x";
  /**
   * Each author's articles. Populated at request time from published MongoDB posts
   * (matched by author name) in app/(marketing)/author/[slug]/page.tsx, so the
   * list always reflects real, published posts and never links to a 404.
   */
  blogs?: {
    slug: string;
    title: string;
    category: string;
    readTime: string;
    date: string;
  }[];
}

export const AUTHORS_DATA: AuthorProfile[] = [
  {
    slug: "shubham-jadhav",
    name: "Shubham Jadhav",
    email: "shubhamjadhav.img@gmail.com",
    role: "Technology & AI Contributor",
    image: "/images/authors/shubham.webp",
    about:
      "Shubham contributes technical insights and analysis on artificial intelligence, conversational agents, and workflow automation for Quto AI.",
    socialLink: "https://www.linkedin.com/in/shubhamjadhav17/",
    socialType: "linkedin",
  },
  {
    slug: "suryabhan-singh",
    name: "Suryabhan Singh",
    email: "suryabhan.img@gmail.com",
    role: "AI & Technology Contributor",
    image: "/images/authors/suryabhan.webp",
    about:
      "Suryabhan writes on modern conversational AI, intelligent voice systems, and enterprise automation practicalities for Quto AI.",
    socialLink: "https://www.linkedin.com/in/suryabhan-singh-287814235",
    socialType: "linkedin",
  },
  {
    slug: "lily-singhal",
    name: "Lily Singhal",
    email: "lilysinghal19@gmail.com",
    role: "Editorial Contributor",
    image: "/images/authors/lily-singhal.webp",
    about:
      "Lily writes on AI automation, customer experience, and conversational technology strategies for Quto AI.",
    socialLink: "https://www.linkedin.com/in/lily-singhal-837955252/",
    socialType: "linkedin",
  },
  {
    slug: "mohit-mittal",
    name: "Mohit Mittal",
    email: "mohit@imgglobalinfotech.com",
    role: "Technology & AI Contributor",
    image: "/images/authors/mohit-mittal.webp",
    about:
      "Mohit focuses on enterprise technology trends, conversational systems, and applied AI workflows for Quto AI.",
    socialLink: "https://www.linkedin.com/in/mohitmittal23/",
    socialType: "linkedin",
  },
];
